import { render } from "./AddExamPaperDialog.vue?vue&type=template&id=78f27b70&scoped=true&ts=true"
import script from "./AddExamPaperDialog.vue?vue&type=script&lang=ts"
export * from "./AddExamPaperDialog.vue?vue&type=script&lang=ts"

import "./AddExamPaperDialog.vue?vue&type=style&index=0&id=78f27b70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f27b70"]])

export default __exports__